import Admin from './Admin';
import AdminRouter from './AdminRouter';
export * from 'ra-core';
export * from 'ra-ui-materialui';
export { Admin, AdminRouter };



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-admin/esm/index.js
// module id = 36
// module chunks = 0